export var CountdownFormat;
(function (CountdownFormat) {
    CountdownFormat["DAY_HOUR_MIN_SEC"] = "dd-hh-mm-ss";
    CountdownFormat["HOUR_MIN_SEC"] = "hh-mm-ss";
    CountdownFormat["MIN_SEC"] = "mm-ss";
    CountdownFormat["SEC"] = "ss";
    CountdownFormat["DAY"] = "dd";
    CountdownFormat["DAY_HOUR"] = "dd-hh";
    CountdownFormat["DAY_HOUR_MIN"] = "dd-hh-mm";
})(CountdownFormat || (CountdownFormat = {}));
export var CountdownUnite;
(function (CountdownUnite) {
    CountdownUnite[CountdownUnite["DAY"] = 0] = "DAY";
    CountdownUnite[CountdownUnite["HOUR"] = 1] = "HOUR";
    CountdownUnite[CountdownUnite["MIN"] = 2] = "MIN";
    CountdownUnite[CountdownUnite["SEC"] = 3] = "SEC";
})(CountdownUnite || (CountdownUnite = {}));
export const getFormatWidth = (format) => {
    switch (format) {
        case CountdownFormat.HOUR_MIN_SEC:
        case CountdownFormat.DAY_HOUR_MIN:
            return '60%';
        case CountdownFormat.MIN_SEC:
        case CountdownFormat.DAY_HOUR:
            return '40%';
        case CountdownFormat.SEC:
        case CountdownFormat.DAY:
            return '20%';
        default:
            return '80%';
    }
};
//# sourceMappingURL=CountdownEnum.js.map